import { Injectable } from '@angular/core'
import { CanActivate, Router } from '@angular/router'
import { AuthService } from './auth/auth.service'

/**
 * @Injectable({ providedIn: 'root' })
 * @export class AuthGuard
 */
@Injectable({
    providedIn: 'root',
})
export class AuthGuard implements CanActivate {
    /**
     * Constructs a new AuthGuard instance.
     *
     * @param auth The AuthService instance for authentication checks.
     * @param router The Router service for navigation.
     */
    constructor(
        private auth: AuthService,
        private router: Router
    ) {}

    /**
     * Guards access to routes based on user authentication.
     *
     * @Injectable({ providedIn: 'root' })
     * @export class AuthGuard implements CanActivate {
     *   constructor(private auth: AuthService, private router: Router) {}
     *
     *   /**
     * Checks if
     * the user is authenticated and redirects to the login page if not.
     *
     * @returns {boolean} `true` if the user is authenticated, `false` otherwise.
     */
    canActivate(): boolean {
        const user: string | null = localStorage.getItem('user')
        if (user != null && user != '') {
            return true
        } else {
            this.router.navigate(['/login'])
            return false
        }
    }
}
